// src/modules/app-views/_apps/appmulti/operators/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatabaseOutlined, ImportOutlined } from '@ant-design/icons';
import showMigrationDocumentModal from 'components/core/migration/MigrationDocumentModal';
import showMigrationModal from 'components/core/migration/MigrationSettingsModal';
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const operatorsInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      {
        key: 'importOperator',
        label: 'migrate_document',
        icon: <ImportOutlined />,
        // Hide item if entities migration token is not active
        hidden: ({ storedSubscription }) => {
          const tokens = storedSubscription?.migrationTokens || [];
          const entitiesToken = tokens.find(t => t.collectionName === 'entities');
          return !entitiesToken?.isActive;
        },
        onClick: ({ refresh }) => {
          showMigrationDocumentModal({
            onSuccess: () => {
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
      'divider',
      dropdownParameters,
      {
        key: 'operatorsMigrationSettings',
        label: 'migrator',
        icon: <DatabaseOutlined />,
        onClick: ({ refresh }) => {
          showMigrationModal({
            onSuccess: () => {
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default operatorsInitMenuButton;
